/* eslint-disable */
import PropTypes from "prop-types";

import Can from "./can";

function ProtectedRoute({ children, failComponent, user, requiredPermission }) {
  return (
    <Can
      user={user}
      perform={requiredPermission}
      ok={() => children}
      nok={() => failComponent}
    />
  );
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  failComponent: PropTypes.elementType.isRequired,
  user: PropTypes.shape({}).isRequired,
  requiredPermission: PropTypes.string.isRequired,
};

ProtectedRoute.defaultProps = {};

export default ProtectedRoute;
